document.addEventListener("DOMContentLoaded", function () {

  /* =========================================================
     BETULLA MAP JS
     File: assets/betulla-map.js

     Usa:
     - Leaflet
     - Google Sheet via OpenSheet
     - Popup card con link prodotto
     - Lightbox "Field note"
     - Filtri attività
     - Blocco/sblocco mappa su mobile

     ID usati:
     - section: bt-map-stable-section
     - map: bt-map-stable-full
     - mobile toggle: betulla-map-toggle

     Colonne Google Sheet:
     - lat
     - lng
     - title
     - product
     - temperature
     - activity
     - note
     - image
     - product_url
     - review
     - home_visible
  ========================================================= */

  /* =========================================================
     ELEMENTI BASE
  ========================================================= */

  const section = document.getElementById("bt-map-stable-section");
  const mapEl = document.getElementById("bt-map-stable-full");
  const toggleBtn = document.getElementById("betulla-map-toggle");

  if (!section || !mapEl || typeof L === "undefined") {
    console.error("Betulla map: elementi mancanti o Leaflet non caricato");
    return;
  }

  const sheetURL = section.dataset.sheetUrl;

  if (!sheetURL) {
    console.error("Betulla map: manca data-sheet-url");
    return;
  }

  /* =========================================================
     MOBILE CHECK
  ========================================================= */

  const isMobile = window.innerWidth <= 768;
  let mapActive = !isMobile;

  /* =========================================================
     MAP INIT
  ========================================================= */

  const map = L.map("bt-map-stable-full", {
    zoomControl: false,
    scrollWheelZoom: false,
    dragging: !isMobile,
    tap: !isMobile,
    touchZoom: !isMobile,
    doubleClickZoom: !isMobile
  });

  /* =========================================================
     TILE LAYER
  ========================================================= */

  L.tileLayer(
    "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
    }
  ).addTo(map);

  /* =========================================================
     FIX DIMENSIONE MAPPA
     Leaflet spesso calcola male le dimensioni se Shopify
     non ha finito di renderizzare la sezione.
  ========================================================= */

  function delayedMapFix() {
    setTimeout(function () {
      map.invalidateSize(true);
    }, 100);

    setTimeout(function () {
      map.invalidateSize(true);
    }, 400);

    setTimeout(function () {
      map.invalidateSize(true);
    }, 900);
  }

  window.addEventListener("load", delayedMapFix);
  window.addEventListener("resize", delayedMapFix);

  /* =========================================================
     MOBILE LOCK / UNLOCK MAP
     Su mobile la mappa parte bloccata per non rovinare
     lo scroll della pagina.
  ========================================================= */

  if (isMobile && toggleBtn) {
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();

    toggleBtn.innerHTML = "Explore map";

    toggleBtn.addEventListener("click", function () {
      mapActive = !mapActive;

      if (mapActive) {
        map.dragging.enable();
        map.touchZoom.enable();
        map.doubleClickZoom.enable();

        toggleBtn.innerHTML = "Lock map";
      } else {
        map.dragging.disable();
        map.touchZoom.disable();
        map.doubleClickZoom.disable();

        toggleBtn.innerHTML = "Explore map";
      }

      delayedMapFix();
    });
  }

  /* =========================================================
     STATO DATI
  ========================================================= */

  let allData = [];
  let markers = [];

  /* =========================================================
     HELPERS
  ========================================================= */

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function escapeHTML(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  /* =========================================================
     HOME VISIBLE
     Se home_visible è vuoto, mostra il punto.
     Se è false/no/0, non lo mostra.
  ========================================================= */

  function isHomeVisible(item) {
    const value = normalize(
      item.home_visible ??
      item.Home_visible ??
      item.HOME_VISIBLE ??
      item.visible_home ??
      item.home ??
      ""
    );

    if (value === "") return true;

    return (
      value === "true" ||
      value === "vero" ||
      value === "si" ||
      value === "sì" ||
      value === "yes" ||
      value === "1"
    );
  }

  /* =========================================================
     NORMALIZZA ATTIVITÀ PER FILTRI
  ========================================================= */

  function normalizeActivity(activity) {
    const value = normalize(activity);

    if (
      value.includes("trek") ||
      value.includes("hiking")
    ) {
      return "trekking";
    }

    if (
      value.includes("bike") ||
      value.includes("mtb") ||
      value.includes("cycling")
    ) {
      return "bike";
    }

    if (
      value.includes("run") ||
      value.includes("trail")
    ) {
      return "running";
    }

    return "other";
  }

  /* =========================================================
     CLEAR MARKERS
  ========================================================= */

  function clearMarkers() {
    markers.forEach(function (marker) {
      map.removeLayer(marker);
    });

    markers = [];
  }

  /* =========================================================
     CREA POPUP MARKER
     Qui nasce la card del marker.
     Se product_url è compilato, il nome prodotto diventa link.
     Se image/review esistono, apre la lightbox.
  ========================================================= */

  function createPopup(test) {
    const product = escapeHTML(test.product || "Betulla Gear");
    const productUrl = escapeHTML(test.product_url || "");
    const title = escapeHTML(test.title || "");
    const temperature = escapeHTML(test.temperature || "");
    const activity = escapeHTML(test.activity || "");
    const note = escapeHTML(test.note || "");
    const review = escapeHTML(test.review || "");
    const image = String(test.image || "").trim();

    /* =====================================================
       IMMAGINE POPUP
    ====================================================== */

    const imageHTML = image
      ? `
        <button
          type="button"
          class="betulla-map-popup-image-button"
          data-map-image="${escapeHTML(image)}"
          data-map-product="${product}"
          data-map-product-url="${productUrl}"
          data-map-title="${title}"
          data-map-temp="${temperature}"
          data-map-activity="${activity}"
          data-map-note="${note}"
          data-map-review="${review}"
          aria-label="Open field note"
        >
          <img
            src="${escapeHTML(image)}"
            alt="${title || product}"
            loading="lazy"
          >
        </button>
      `
      : "";

    /* =====================================================
       NOME PRODOTTO
       Diventa link se product_url è compilato.
    ====================================================== */

    const productHTML = productUrl
      ? `
        <a
          href="${productUrl}"
          class="betulla-map-popup-product-link"
        >
          ${product}
        </a>
      `
      : `
        <strong class="betulla-map-popup-product">
          ${product}
        </strong>
      `;

    /* =====================================================
       META
    ====================================================== */

    const metaHTML =
      activity || temperature
        ? `
          <div class="betulla-map-popup-meta">
            ${activity || ""}
            ${activity && temperature ? " · " : ""}
            ${temperature || ""}
          </div>
        `
        : "";

    /* =====================================================
       TITOLO TEST
    ====================================================== */

    const titleHTML = title
      ? `
        <div class="betulla-map-popup-title">
          ${title}
        </div>
      `
      : "";

    /* =====================================================
       NOTA BREVE
    ====================================================== */

    const noteHTML = note
      ? `
        <p class="betulla-map-popup-note">
          ${note}
        </p>
      `
      : "";

    /* =====================================================
       CTA FIELD NOTE
       Apre la lightbox.
    ====================================================== */

    const ctaHTML = review || image
      ? `
        <button
          type="button"
          class="betulla-map-popup-cta"
          data-map-image="${escapeHTML(image)}"
          data-map-product="${product}"
          data-map-product-url="${productUrl}"
          data-map-title="${title}"
          data-map-temp="${temperature}"
          data-map-activity="${activity}"
          data-map-note="${note}"
          data-map-review="${review}"
        >
          Open field note
        </button>
      `
      : "";

    /* =====================================================
       HTML FINALE CARD
    ====================================================== */

    return `
      <article class="betulla-map-popup">

        ${imageHTML}

        <div class="betulla-map-popup-body">

          <div class="betulla-map-popup-kicker">
            Field note
          </div>

          ${productHTML}
          ${metaHTML}
          ${titleHTML}
          ${noteHTML}
          ${ctaHTML}

        </div>

      </article>
    `;
  }

  /* =========================================================
     RENDER MAP
  ========================================================= */

  function renderMap(data) {
    clearMarkers();

    const bounds = [];

    data.forEach(function (test) {
      if (!test.lat || !test.lng) return;

      const lat = parseFloat(
        String(test.lat).replace(",", ".")
      );

      const lng = parseFloat(
        String(test.lng).replace(",", ".")
      );

      if (
        Number.isNaN(lat) ||
        Number.isNaN(lng)
      ) {
        return;
      }

      bounds.push([lat, lng]);

      const marker = L.circleMarker([lat, lng], {
        radius: 9,
        color: "#ffffff",
        fillColor: "#111111",
        fillOpacity: 1,
        weight: 2
      });

      marker
        .addTo(map)
        .bindPopup(createPopup(test), {
          closeButton: true,
          maxWidth: 460
        });

      markers.push(marker);
    });

    /* =====================================================
       FIT BOUNDS
    ====================================================== */

    if (bounds.length > 0) {
      delayedMapFix();

      setTimeout(function () {
        map.fitBounds(bounds, {
          padding: isMobile ? [40, 40] : [90, 90],
          maxZoom: 5
        });

        delayedMapFix();
      }, 250);
    } else {
      map.setView([45.5, 11.5], 4);
      delayedMapFix();
    }
  }

  /* =========================================================
     LIGHTBOX ELEMENTS
  ========================================================= */

  const mapLightbox = document.querySelector("[data-map-lightbox]");
  const mapLightboxImage = document.querySelector("[data-map-lightbox-image]");
  const mapLightboxClose = document.querySelector("[data-map-lightbox-close]");
  const mapLightboxProduct = document.querySelector("[data-map-lightbox-product]");
  const mapLightboxTitle = document.querySelector("[data-map-lightbox-title]");
  const mapLightboxMeta = document.querySelector("[data-map-lightbox-meta]");
  const mapLightboxNote = document.querySelector("[data-map-lightbox-note]");

  /* =========================================================
     OPEN LIGHTBOX
  ========================================================= */

  function openMapLightbox(data) {
    if (!mapLightbox || !mapLightboxImage) return;

    mapLightboxImage.src = data.image || "";
    mapLightboxImage.alt = data.title || data.product || "Betulla field note";

    if (mapLightboxProduct) {
      if (data.productUrl) {
        mapLightboxProduct.innerHTML = `
          <a href="${data.productUrl}">
            ${data.product || ""}
          </a>
        `;
      } else {
        mapLightboxProduct.innerHTML = data.product || "";
      }
    }

    if (mapLightboxTitle) {
      mapLightboxTitle.innerHTML = data.title || "";
    }

    if (mapLightboxMeta) {
      let meta = "";

      if (data.activity) meta += data.activity;
      if (data.activity && data.temperature) meta += " · ";
      if (data.temperature) meta += data.temperature;

      mapLightboxMeta.innerHTML = meta;
    }

    if (mapLightboxNote) {
      mapLightboxNote.innerHTML = data.review || data.note || "";
    }

    mapLightbox.classList.add("is-open");
    mapLightbox.setAttribute("aria-hidden", "false");

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  /* =========================================================
     CLOSE LIGHTBOX
  ========================================================= */

  function closeMapLightbox() {
    if (!mapLightbox || !mapLightboxImage) return;

    mapLightbox.classList.remove("is-open");
    mapLightbox.setAttribute("aria-hidden", "true");

    mapLightboxImage.src = "";
    mapLightboxImage.alt = "";

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }

  /* =========================================================
     CLICK POPUP
     Apre la lightbox quando clicchi:
     - immagine popup
     - bottone Open field note
  ========================================================= */

  document.addEventListener("click", function (event) {
    const trigger =
      event.target.closest(".betulla-map-popup-image-button") ||
      event.target.closest(".betulla-map-popup-cta");

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    openMapLightbox({
      image: trigger.getAttribute("data-map-image"),
      product: trigger.getAttribute("data-map-product"),
      productUrl: trigger.getAttribute("data-map-product-url"),
      title: trigger.getAttribute("data-map-title"),
      temperature: trigger.getAttribute("data-map-temp"),
      activity: trigger.getAttribute("data-map-activity"),
      note: trigger.getAttribute("data-map-note"),
      review: trigger.getAttribute("data-map-review")
    });
  }, true);

  /* =========================================================
     CHIUSURA LIGHTBOX CON X
  ========================================================= */

  if (mapLightboxClose) {
    mapLightboxClose.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeMapLightbox();
    });
  }

  /* =========================================================
     CHIUSURA LIGHTBOX CLICCANDO OVUNQUE

     Comportamento:
     - click sul link prodotto: apre il link e NON chiude
     - click su qualunque altra area della lightbox: chiude

     Sì, è volutamente semplice.
     Se clicchi dentro il field note, si chiude.
     Lo hai chiesto tu, così evitiamo il solito balletto
     "ho cliccato ma non era proprio il div giusto".
  ========================================================= */

  if (mapLightbox) {
    mapLightbox.addEventListener("click", function (event) {
      const productLink = event.target.closest(
        "[data-map-lightbox-product] a"
      );

      if (productLink) {
        return;
      }

      closeMapLightbox();
    });
  }

  /* =========================================================
     CHIUSURA LIGHTBOX CON ESC
  ========================================================= */

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeMapLightbox();
    }
  });

  /* =========================================================
     FETCH DATI DA OPENSHEET
  ========================================================= */

  fetch(sheetURL)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      allData = Array.isArray(data)
        ? data.filter(isHomeVisible)
        : [];

      renderMap(allData);
    })
    .catch(function (error) {
      console.error("Betulla map error:", error);

      map.setView([45.5, 11.5], 4);
      delayedMapFix();
    });

  /* =========================================================
     FILTRI ATTIVITÀ
  ========================================================= */

  document
    .querySelectorAll(".betulla-filter")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        document
          .querySelectorAll(".betulla-filter")
          .forEach(function (btn) {
            btn.classList.remove("active");
          });

        this.classList.add("active");

        const filter = this.dataset.filter;

        if (filter === "all") {
          renderMap(allData);
          return;
        }

        const filtered = allData.filter(function (item) {
          return normalizeActivity(item.activity) === filter;
        });

        renderMap(filtered);
      });
    });

  /* =========================================================
     INIT SIZE FIX
  ========================================================= */

  delayedMapFix();

});